import axios from 'axios';
import store from '@/store/registration';

const config = {
  baseURL: '/',
  headers: {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
};

const call = axios.create(config);
call.interceptors.request.use(request => {
  store.dispatch('globalValues/setLoading', true);
  return request;
});

call.interceptors.response.use(
  response => {
    store.dispatch('globalValues/setLoading', false);
    return response;
  },
  error => {
    store.dispatch('globalValues/setLoading', false);
    return error;
  }
);

export default call;
